/*
 * # Example of Usage:
 *
 * 1 - Basic usage
 *   <CollapseText height={95}>
 *     *Insert a whole lot of content here*
 *   </CollapseText>
 * #Note: This component doesn't consider images
 */

var cx = require("classnames");
var PureRenderMixin = React.addons.PureRenderMixin;

var CollapseText = React.createClass({
  mixins: [PureRenderMixin, ReactIntl.IntlMixin],
  propTypes: {
    children: React.PropTypes.node.isRequired,
    height: React.PropTypes.number
  },
  getDefaultProps: function() {
    return {
      height: 200
    };
  },
  getInitialState: function() {
    return {
      isCollapsed: true,
      isContentTooBig: false
    };
  },
  componentDidMount: function() {
    this.defineIsContentTooBig();
  },
  componentDidUpdate: function() {
    this.defineIsContentTooBig();
  },
  defineIsContentTooBig: function() {
    if (this.refs.content.offsetHeight > this.props.height) {
      this.setState({ isContentTooBig: true });
    } else if (this.state.isContentTooBig) {
      this.setState({ isContentTooBig: false });
    }
  },
  getHeight: function() {
    if (this.state.isCollapsed && this.state.isContentTooBig) {
      return { height: this.props.height };
    } else if (this.refs.content && this.refs.content.offsetHeight) {
      return { height: this.refs.content.offsetHeight };
    } else {
       return {};
    }
  },
  toggleCollapse: function() {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  },
  getText: function() {
    if (this.state.isCollapsed) {
      return this.getIntlMessage("view_more");
    }
    return this.getIntlMessage("view_less");
  },
  render: function() {
    var className = cx(
      "ww-bw", "transition-height",
      { "collapse-text ovf-h": this.state.isCollapsed && this.state.isContentTooBig }
    );

    return (
      <div>
        <div className={className} style={this.getHeight()}>
          <div ref="content">
            {this.props.children}
          </div>
        </div>
        {
          this.state.isContentTooBig
          ? <ToggleView onClick={this.toggleCollapse} text={this.getText()} />
          : null
        }
      </div>
    );
  }
});

const ToggleView = (props) => (
  <div className="ta-c mt-5">
    <a className="c-pointer fs-14 fw-500" onClick={props.onClick}>{props.text}</a>
  </div>
);

ToggleView.propTypes = {
  onClick: React.PropTypes.func.isRequired,
  text: React.PropTypes.string.isRequired
};

module.exports = CollapseText;



// WEBPACK FOOTER //
// ./app/shared/components/CollapseText/collapse-text.jsx